import React, {useEffect, useState} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import {RouteComponentProps} from 'react-router-dom'
import Action from 'src/models/Action'
import {actions as actionActions} from 'src/redux/modules/actions'
import {RootState} from '../../redux/rootReducer'
import {Root} from './styled'
import ActionForm from 'src/components/ActionForm'
import {actionTypesSelectors, bodyAreasSelectors, equipmentSelectors} from 'src/redux/selectors'

export type TParams = {id: string}
export type ActionEditProps = RouteComponentProps<TParams> & {}

const {selectBodyAreas} = bodyAreasSelectors
const {selectEquipment} = equipmentSelectors
const {selectActionTypes} = actionTypesSelectors

const ActionPage: React.FC<ActionEditProps> = ({match, history}: ActionEditProps) => {
  const dispatch = useDispatch()
  const allBodyAreas = useSelector(selectBodyAreas)
  const allEquipment = useSelector(selectEquipment)
  const allActionTypes = useSelector(selectActionTypes)
  const {actions, dataState} = useSelector((state: RootState) => state.actions)
  const [isSaving, setIsSaving] = useState<boolean>(false)
  const [isSuccess, setIsSuccess] = useState<boolean>(false)

  const id = match?.params?.id
  let action: Action
  if (!id) {
    action = {
      title: '',
      description: '',
      equipment: [],
      setsAndReps: '',
      steps: '',
      thumbnailUrl: '',
      videoUrl: '',
    } as unknown as Action
  } else {
    action = actions[id] as Action
  }

  ///
  /// Called to update this action.
  ///
  const saveAction = async (updatedAction: Action, videoFile?: File) => {
    dispatch(actionActions.saveAction({action: updatedAction, videoFile}))
    // Set the flag
    setIsSaving(true)
  }

  const loadAction = () => {
    if (id) {
      dispatch(actionActions.getAction({id}))
      setIsSaving(false)
    }
  }
  useEffect(loadAction, [dispatch, id])

  useEffect(() => {
    if (isSaving && dataState.state !== 'loading') {
      // Finished saving.
      setIsSaving(false)

      if (!dataState.error) {
        // And no error!
        setIsSuccess(true)
      }
    }
  }, [isSaving, dataState])

  const onCancelAction = () => {
    history.goBack()
  }

  const busyString = isSaving
    ? 'Saving Action...'
    : dataState.state === 'loading'
    ? 'Loading Action...'
    : undefined

  const successString = isSuccess ? (id ? 'Action Updated!' : 'Action Created!') : undefined

  const title = id ? 'Update Action' : 'Create Action'

  return (
    <Root maxWidth="lg">
      <ActionForm
        title={title}
        action={action}
        allBodyAreas={allBodyAreas}
        allEquipment={allEquipment}
        allActionTypes={allActionTypes}
        busyString={busyString}
        successString={successString}
        onSavePress={saveAction}
        onCancel={onCancelAction}
        onDismissSuccess={() => history.goBack()}
        errorMessage={dataState.error?.message}
      />
    </Root>
  )
}

export default ActionPage
